import { useMemo } from 'react';
import { MenuNavigationShellPage } from '@/app/layout/MenuNavigationShellPage';
import type { AgendaRegistration } from '@/app/layout/MenuNavigationShellPage';
import { plannerAgenda } from './plannerAgenda';
import { PlannerShellPage } from './PlannerShellPage';
import { projectFormAgenda, ProjectFormPage } from './project';
import { serieFormAgenda, SerieFormPage, serieDetailAgenda, SerieDetailPage } from './serie';
import {
  productFormAgenda,
  ProductFormPage,
  productDetailAgenda,
  ProductDetailPage,
} from './product';
import { PLANNER_PERMISSION } from './permissions';

/**
 * Route entry pro planner slice.
 *
 * Registruje root planner agendu v navigačním kernelu a deleguje rendering na
 * `MenuNavigationShellPage` (shell s hlavním menu, footerem a navigačním kontejnerem).
 *
 * Zakládací a detail agendy byly odebrané — vzniknou znovu s novými návrhy. Zatím zůstává
 * jen root agenda s treeview.
 */
export function PlannerSlicePage() {
  const agendas: AgendaRegistration[] = useMemo(
    () => [
      { agenda: plannerAgenda, component: PlannerShellPage, permission: PLANNER_PERMISSION },
      {
        agenda: projectFormAgenda,
        component: ProjectFormPage,
        permission: PLANNER_PERMISSION,
      },
      {
        agenda: productFormAgenda,
        component: ProductFormPage,
        permission: PLANNER_PERMISSION,
      },
      { agenda: serieFormAgenda, component: SerieFormPage, permission: PLANNER_PERMISSION },
      {
        agenda: productDetailAgenda,
        component: ProductDetailPage,
        permission: PLANNER_PERMISSION,
      },
      {
        agenda: serieDetailAgenda,
        component: SerieDetailPage,
        permission: PLANNER_PERMISSION,
      },
    ],
    []
  );

  return <MenuNavigationShellPage agendas={agendas} rootAgenda={plannerAgenda} />;
}
